import { OrderState, OrderType } from "src/app/proxy/orders/enums";
import { ProductOrder } from "./product-order";
import { OrderDto } from "src/app/proxy/orders";
import { v4 as uuidv4 } from "uuid";

export class Order {
  id?: number;
  localId: string;
  name?: string;
  requesterId: number;
  requesterName?: string;
  originRegionId: number;
  originWarehouseId: number;
  originWarehouseManagerId?: number;
  originWarehouseName?: string;
  approverId: number;
  approverName?: string;
  destinationRegionId: number;
  destinationWarehouseId: number;
  destinationWarehouseManagerId?: number;
  destinationWarehouseName?: string;
  orderState: OrderState;
  movementDate?: string;
  creationDate?: string;
  requestedDate?: string;
  approvalDate?: string;
  deliveryDate?: string;
  receivedDate?: string;
  observations?: string;
  products: ProductOrder[];
  pendingSend: boolean;
  motiveId: number;
  orderType: OrderType;
  establishmentId: number;
  purchaseOrderNumber?: string;
  vendorName?: string;
  deliveryNumber?: string;
  rowVersion?: string;
  lastModificationDate?: string;

  constructor(dto: Order | OrderDto) {
    Object.assign(this, dto);
    if (!this.localId) {
      this.localId = uuidv4();
    }
  }

  displayName(currentUserId: number): string {
    if (currentUserId !== this.requesterId) {
      return this.requesterName ?? '';
    } else if (this.orderState === OrderState.New || this.orderState === OrderState.Rejected) {
      return this.approverName ?? '';
    } else if (this.orderState === OrderState.Approved) {
      return this.originWarehouseName ?? '';
    } else if (this.orderState === OrderState.Delivered) {
      return this.destinationWarehouseName ?? '';
    }

    return '';
  }
}
